import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { Flex } from "@utilitywarehouse/hearth-react";

import { ABOUT_ROUTES } from "../../config/routeConfig";
import { useConfirmPageClose } from "../../hooks/useConfirmPageClose";
import useTrackVulnerabilityJourney from "../../middleware/analytics/hooks/useTrackVulnerabilityJourney";
import { checkTokenExpiryOnInterval } from "../../context/auth/Token";
import Unauthenticated from "../../components/Unauthenticated";
import { useAuthContext } from "../../context/auth/useAuthContext";

import Age from "./Age/Age";
import Children from "./Children/Children";
import Financial from "./Financial/Financial";
import FinancialDetail from "./Financial/FinancialDetail";
import Hearing from "./Hearing/Hearing";
import MedicalEquipment from "./MedicalEquipment/MedicalEquipment";
import MedicalEquipmentDetail from "./MedicalEquipment/MedicalEquipmentDetail";
import Miscellaneous from "./Miscellaneous/Miscellaneous";
import Sight from "./Sight/Sight";
import ChronicIllness from "./ChronicIllness/ChronicIllness";
import ChronicIllnessDetail from "./ChronicIllness/ChronicIllnessDetail";
import SightDetail from "./Sight/SightDetail";
import AgeDetail from "./Age/AgeDetail";
import AgeCare from "./Age/AgeCare";
import DailyActivity from "./DailyActivity/DailyActivity";
import DailySupport from "./DailySupport/DailySupport";

const About: React.FC = () => {
  const { setAuthenticated, authenticated } = useAuthContext();

  useConfirmPageClose();

  const location = useLocation();
  const { trackVulnerabilityJourneyOpen } = useTrackVulnerabilityJourney();

  const routesArray = Object.values(ABOUT_ROUTES);

  const matchingSteps = routesArray.filter((v) =>
    location.pathname.includes(v)
  );
  const stepTitle = matchingSteps[matchingSteps.length - 1];

  const totalSteps = routesArray.length;
  const currentStep = routesArray.lastIndexOf(stepTitle) + 1;

  useEffect(() => {
    trackVulnerabilityJourneyOpen(stepTitle, `${currentStep} of ${totalSteps}`);
  }, [location]);

  useEffect(() => {
    checkTokenExpiryOnInterval(authenticated, setAuthenticated);
  }, []);

  if (!authenticated) {
    return <Unauthenticated />;
  }

  return (
    <Flex direction="column" maxWidth="700px" marginTop="150">
      <Routes>
        <Route
          path={ABOUT_ROUTES.Children}
          element={<Children />}
        />
        <Route
          path={ABOUT_ROUTES.Sight}
          element={<Sight />}
        />
        <Route
          path={ABOUT_ROUTES.SightDetail}
          element={<SightDetail />}
        />
        <Route
          path={ABOUT_ROUTES.Hearing}
          element={<Hearing />}
        />
        <Route
          path={ABOUT_ROUTES.Age}
          element={<Age />}
        />
        <Route
          path={ABOUT_ROUTES.AgeDetail}
          element={<AgeDetail />}
        />
        <Route
          path={ABOUT_ROUTES.AgeCareDetail}
          element={<AgeCare />}
        />
        <Route
          path={ABOUT_ROUTES.MedicalEquipment}
          element={<MedicalEquipment />}
        />
        <Route
          path={ABOUT_ROUTES.MedicalEquipmentDetail}
          element={<MedicalEquipmentDetail />}
        />
        <Route
          path={ABOUT_ROUTES.MiscellaneousDetail}
          element={<Miscellaneous />}
        />
        <Route
          path={ABOUT_ROUTES.ChronicIllness}
          element={<ChronicIllness />}
        />
        <Route
          path={ABOUT_ROUTES.ChronicIllnessDetail}
          element={<ChronicIllnessDetail />}
        />
        <Route
          path={ABOUT_ROUTES.Financial}
          element={<Financial />}
        />
        <Route
          path={ABOUT_ROUTES.FinancialDetail}
          element={<FinancialDetail />}
        />
        <Route
          path={ABOUT_ROUTES.DailyActivity}
          element={<DailyActivity />}
        />
        <Route
          path={ABOUT_ROUTES.DailySupport}
          element={<DailySupport />}
        />
        <Route
          path='*'
          element={<Navigate to={ABOUT_ROUTES.Children} />}
        />
      </Routes>
    </Flex>
  )
};

export default About;
